import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '..\\node_modules\\quill\\dist\\quill.snow.css'

import '..\\node_modules\\quill\\dist\\quill.core.css'

import '..\\css\\reset.less'

import '..\\css\\app.less'

import '..\\css\\components\\index.less'

import '..\\css\\room.less'

import '..\\css\\vip.less'

import '..\\css\\viproom.less'

import '..\\css\\article.less'

import '..\\css\\user.less'

import '..\\css\\question.less'

import '..\\css\\login.less'

import _160badf6 from '..\\layouts\\activity.vue'
import _770c0138 from '..\\layouts\\apply.vue'
import _6f6c098b from '..\\layouts\\default.vue'

const layouts = { "_activity": _160badf6,"_apply": _770c0138,"_default": _6f6c098b }

export default {
  head: {"title":"一富财经_专注理财知识普及_陪伴市场健康成长","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"referrer","content":"no-referrer"},{"hid":"keywords","name":"keywords","content":"实时行情_投资者交流_趋势解盘_深度分析"},{"hid":"description","name":"description","content":"一富财经致力于为用户提供基础理财知识及市场信息，是一个供大家学习与交流的线上社区。一富财经网(www.yifucj.com)"},{"name":"format-detection","content":"telephone=no"},{"name":"baidu-site-verification","content":"dl6gj1sBLN"}],"link":[{"rel":"stylesheet","href":"\u002F\u002Fat.alicdn.com\u002Ft\u002Ffont_67979_269wbb4mki3.css"}],"style":[],"script":[]},

  render(h, props) {
    const loadingEl = h('nuxt-loading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,
      transitionEl
    ])
  },
  data: () => ({
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (typeof window !== 'undefined') {
      window.$nuxt = this
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  methods: {
    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if(layout && typeof layout !== 'string') throw new Error('[nuxt] Avoid using non-string value as layout property.')

      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
  components: {
    NuxtLoading
  }
}
